<template>
  <div>
    <div class="main">
      <div class="head">
        <h2>アカウント残高</h2>
        <p>
          現在ご利用可能の金額：{{ balance.balance }}円
          <span>入金確認待ち金額：{{ balance.needConfirmBalance }}円</span>
        </p>
      </div>
      <div class="content">
        <h2>振込先</h2>
        <ul>
          <li>
            <div class="img" :class="{ imgBorder: index == 1 }" @click="index = 1">
              <img src="../../../assets/img/paypal (1).png" alt />
            </div>
          </li>
          <li>
            <div class="img" :class="{ imgBorder: index == 2 }" @click="index = 2">
              <img src="../../../assets/img/netBank.webp" alt />
            </div>
          </li>
        </ul>
        <div class="container" v-if="index == 1">
          <p>１、チャージする金額を入力してください。</p>
          <p>
            ２、ペイパル入金の場合、さらに4％手数料が必要になりますので、
            <br />予めご了承ください。
          </p>
          <div class="golden">
            <form action="https://www.paypal.com/cgi-bin/webscr" method="post" name="E_FORM" id="form">
              <div class="input">
                <span>円</span>
                <input type="text" v-model="paypal" oninput="this.value=this.value.replace(/[^\d.]/g,'')" />
              </div>
              <span class="span">請求料金:{{ Math.ceil(paypal * 1.04) }}</span>

              <i>（手数料:4%）</i>

              <input type="hidden" name="add" value="1" />
              <input type="hidden" name="cmd" value="_xclick" />
              <!-- 周六传 -->
              <input type="hidden" name="business" value="paypal_muzaiko@rakumart.com" />
              <input type="hidden" name="amount" :value="Math.ceil(paypal * 1.04)" />
              <input type="hidden" name="no_shipping" value="1" />
              <input type="hidden" name="no_note" :value="order" />
              <!-- <input type="hidden" name="invoice" :value="order" /> -->
              <input type="hidden" name="currency_code" value="JPY" />
              <input type="hidden" name="bn" value="no_shipping" />
              <input type="hidden" name="rm" value="2" />
              <input type="hidden" name="item_name" :value="order" />
              <input type="hidden" name="notify_url"
                :value="`http://www.rakumart-2c.com/index.php?mod=ajax&act=paypal&kin=${paypal}&no=${order}&user_id=${$store.state.userInfo.data.id}`" />
              <input type="hidden" name="cancel_return" value="http://www.rakumart-2c.com/#/user/golden" />
              <a href="javascript:;" @click="PayPal">PayPalへ</a>
              <!-- <button>PayPalへ</button> -->
              <input type="hidden" name="return_url"
                :value="`http://www.rakumart-2c.com/index.php?mod=user&user_id=&user_id=${$store.state.userInfo.data.id}`" />
              <input type="hidden" name="return" value="http://www.rakumart-2c.com/#/user/golden" />
              <!-- <PayPal
              amount="10.00"
              currency="USD"
              :client="credentials"
              env="production"
              :button-style="buttonStyle"
              @payment-authorized="paymentAuthorized"
              @payment-completed="paymentCompleted"
              @payment-cancelled="paymentCancelled"
            >
            </PayPal> -->
            </form>
          </div>
        </div>
        <div class="container" v-if="index == 2">
          <div class="fl">
            <h6>銀行名:ドコモSMTBネット銀行(旧住信SBIネット銀行)</h6>
            <h6>支店番号：106</h6>
            <h6>支店名：法人第一支店</h6>
            <h6>預金種目：普通預金</h6>
            <h6>口座番号： 1302487</h6>
            <h6>口座名義：ラクマート（カ）</h6>
          </div>
          <div class="fr" style="margin-right: 40px">
            <p>１、銀行入金する金額を入力してください</p>
            <p>
              ２、銀行入金額は見積り総額より上回るように入力を
              <br />お願い致します
            </p>
            <p>
              3、入金名義について、必ず入金報告提出時のと同じな
              <br />るようにお願い致します、違う場合、特定できず、入
              <br />金反映が著しく遅くなってしまいます。
            </p>
          </div>
          <ol>
            <li><i>*</i>入金日</li>
            <li><i>*</i>入金名義</li>
            <li><i>*</i>入金額</li>
            <li><i>*</i>備考欄</li>
            <li></li>
          </ol>
          <ul>
            <li>
              <el-date-picker v-model="list.datetime" type="date" placeholder="选择日期"
                value-format="yyyy-MM-dd"></el-date-picker>
            </li>
            <li>
              <input type="text" v-model="youzheng.mingyi" />
            </li>
            <li>
              <input type="text" v-model="youzheng.kin" oninput="this.value=this.value.replace(/[^\d.]/g,'')" />
            </li>
            <li>
              <input type="text" v-model="youzheng.beikao" />
            </li>
            <li>
              <a href="javascript:;" @click="youZheng">提出</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { recharge, balanceTotal, Paypal } from "../../../api/API/user";
import PayPal from "vue-paypal-checkout";
export default {
  data() {
    return {
      credentials: {
        sandbox:
          "AUrgPXKBGAKvCUZxpN_TBkjc0nY9CQIciZSf1UkOEXmMgiCrUmHAGd5Q4C5ly7evMduxlFQAtFJkhaav",
        production: "rakumart_japan@yahoo.co.jp",
      },
      buttonStyle: {
        label: "pay",
        size: "small",
        shape: "rect",
        color: "blue",
      },
      order: "",
      index: 0,
      balance: {}, //用户余额和待确认余额
      time: "", // 当前时间
      paypal: "", // paypal 金额
      // 邮政银行
      youzheng: {
        mingyi: "",
        kin: "",
        beikao: "",
      },
      // 日本银行
      JapanYH: {
        mingyi: "",
        kin: "",
        beikao: "",
      },
      // 请求
      list: {
        mod: "inc",
        act: "ordersys",
        str: "recharge",
        token: localStorage.getItem("token"),
        mingyi: "",
        kin: "",
        beikao: "",
        ordsts: "",
        datetime: "",
      },
    };
  },
  components: {
    PayPal,
  },
  created() {
    this.getCurrentDate();
    this.balanceTotal();
    this.list.datetime = this.time;
  },
  methods: {
    // 查询用户余额和待确认余额
    balanceTotal() {
      let list = {
        mod: "inc",
        act: "ordersys",
        str: "balanceTotal",
        token: localStorage.getItem("token"),
      };
      balanceTotal(list).then((res) => {
        this.balance = res.data;
      });
    },
    //当前时间
    getCurrentDate() {
      var now = new Date();
      var year = now.getFullYear(); //得到年份
      var month = now.getMonth(); //得到月份
      var date = now.getDate(); //得到日期
      var day = now.getDay(); //得到周几
      var hour = now.getHours(); //得到小时
      var minu = now.getMinutes(); //得到分钟
      var sec = now.getSeconds(); //得到秒
      month = month + 1;
      if (month < 10) month = "0" + month;
      if (date < 10) date = "0" + date;
      if (hour < 10) hour = "0" + hour;
      if (minu < 10) minu = "0" + minu;
      if (sec < 10) sec = "0" + sec;
      //   //精确到天
      //   if(format==1){
      //     time = year + "-" + month + "-" + date;
      //   }
      //精确到分
      //   else if(format==2){
      this.time = year + "-" + month + "-" + date;
      //+ " " + hour + ":" + minu + ":" + sec;
      //   }
      //   return time;
    },
    // paypal 充值
    PayPal() {
      var time = "";
      var now = new Date();
      var year = now.getFullYear(); //得到年份
      var month = now.getMonth(); //得到月份
      var date = now.getDate(); //得到日期
      var day = now.getDay(); //得到周几
      var hour = now.getHours(); //得到小时
      var minu = now.getMinutes(); //得到分钟
      var sec = now.getSeconds(); //得到秒
      month = month + 1;
      if (month < 10) month = "0" + month;
      if (date < 10) date = "0" + date;
      if (hour < 10) hour = "0" + hour;
      if (minu < 10) minu = "0" + minu;
      if (sec < 10) sec = "0" + sec;
      this.order =
        "P" +
        year +
        month +
        date +
        hour +
        minu +
        sec +
        "-" +
        this.$store.state.userInfo.data.id;
      console.log(this.order);

      if (this.paypal == "" || this.paypal == 0) {
        return this.$message.error(
          "金額は空欄ではなく、0より大きくなければならない"
        );
      }
      if (this.paypal < 1000) {
        this.$alert(
          "paypal入金の場合は最低1000円からのチャージになります。",

          {
            confirmButtonText: "确定",
            center: true,
            callback: (action) => { },
          }
        );

        return false;
      }
      setTimeout(function () {
        let form = document.querySelector("#form");
        form.submit();
      }, 1000);
    },

    // 邮政充值
    youZheng() {
      this.list.ordsts = 2;
      this.list.kin = this.youzheng.kin;
      this.list.mingyi = this.youzheng.mingyi;
      this.list.beikao = this.youzheng.beikao;
      if (this.youzheng.mingyi == "") {
        return this.$message.error("输入入金名義");
      } else if (this.youzheng.kin == "") {
        return this.$message.error("输入入金額");
      }
      recharge(this.list).then((res) => {
        if (res.code != 1)
          return this.$message.error(
            "操作エラー、再度操作されでもエラーになる場合は担当者までご連絡ください。"
          );
        this.$message.success("チャージ報告完了");
        this.$router.push("/user/goldenRecord");
      });
    },
    //日本银行充值
    Japan() {
      this.list.ordsts = 5;
      this.list.kin = this.JapanYH.kin;
      this.list.mingyi = this.JapanYH.mingyi;
      this.list.beikao = this.JapanYH.beikao;
      if (this.JapanYH.mingyi == "") {
        return this.$message.error("输入入金名義");
      } else if (this.JapanYH.kin == "") {
        return this.$message.error("输入入金額");
      } else if (this.JapanYH.beikao == "") {
        return this.$message.error("输入備考欄");
      }
      recharge(this.list).then((res) => {
        if (res.code != 1)
          return this.$message.error(
            "操作エラー、再度操作されでもエラーになる場合は担当者までご連絡ください。"
          );
        this.$message.success("チャージ報告完了");
      });
    },
    paymentAuthorized(data) {
      // 授权完成的回调，可以拿到订单id
      console.log(data, 1);
    },

    paymentCompleted(data) {
      // 用户支付完成的回调，可以拿到订单id
      console.log(data, 2);
    },

    paymentCancelled(data) {
      // 用户取消交易的回调
      console.log(data, 3);
    },
  },
};
</script>
<style lang='scss' scoped>
.main {
  width: 1208px;

  input {
    font-size: 18px;
  }

  h6 {
    line-height: 20px !important;
    font-style: 18px !important;
  }

  .head {
    border: 1px solid #ccc;

    h2 {
      height: 40px;
      line-height: 40px;
      background: #eee;
      padding-left: 20px;
      font-size: 18px;
      font-weight: bold;
      border-bottom: 1px solid #ccc;
    }

    p {
      height: 180px;
      line-height: 180px;
      padding-left: 100px;
      font-size: 18px;

      span {
        margin-left: 300px;
      }
    }
  }

  .content {
    margin-top: 20px;
    border: 1px solid #ccc;
    overflow: hidden;
    padding-bottom: 20px;

    h2 {
      height: 40px;
      line-height: 40px;
      background: #eee;
      padding-left: 20px;
      font-size: 18px;
      font-weight: bold;
      border-bottom: 1px solid #ccc;
    }

    ul {
      display: flex;

      li {
        flex: 1;

        .img {
          width: 152px;
          height: 80px;
          border: 2px solid transparent;
          margin: 40px auto 30px;

          img {
            width: 152px;
            height: 80px;
          }
        }

        .imgBorder {
          border: 2px solid #f3c622;
        }
      }
    }

    .container {
      padding-left: 50px;
      overflow: hidden;
      padding-bottom: 20px;

      form {
        display: inline-block;
      }

      p {
        font-size: 18px;
        line-height: 25px;
      }

      .golden {
        margin-top: 50px;

        .input {
          display: inline-block;
          position: relative;
          margin-left: 20px;

          span {
            position: absolute;
            top: 3px;
            left: 5px;
            font-size: 30px;
            border-right: 1px solid #f3c622;
            // font-weight: 700;
          }

          input {
            height: 45px;
            width: 140px;
            border: 1px solid #f3c622;
            border-radius: 5px;
            padding-left: 40px;
            font-size: 30px;
          }
        }

        .span {
          font-size: 23px;
          margin-left: 40px;
        }

        button,
        a {
          display: inline-block;
          width: 100px;
          height: 45px;
          text-align: center;
          line-height: 45px;
          background: #f3c622;
          color: #fff;
          font-size: 18px;
          border-radius: 5px;
          margin-left: 10px;
        }

        i {
          color: #f3c622;
          margin-left: 10px;
          font-style: normal;
        }
      }

      ol {
        padding-top: 50px;
        display: flex;
        width: 800px;
      }

      li {
        flex: 1;
        float: left;
        text-align: center;
        font-size: 18px;

        i {
          font-style: normal;
          color: #f3c622;
        }
      }

      ul {
        margin-top: 30px;
        width: 800px;

        li {
          height: 40px;

          a {
            display: block;
            width: 100px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            border-radius: 5px;
            background: #f3c622;
            color: #fff;
            margin-left: 30px;
          }
        }

        input {
          height: 38px;
          width: 140px;
          border-radius: 5px;
          border: 1px solid #f3c622;
        }
      }
    }
  }

  /deep/ .el-date-editor {
    height: 38px;
    width: 140px;
    border-radius: 5px;

    // border: 1PX solid #F3C622;
    .el-input__inner {
      border: 1px solid #f3c622;
      height: 38px;
      width: 140px;
    }
  }

  /deep/ .el-picker-el-date-table th {
    text-align: center;
  }
}
</style>